import React from 'react';
export function Hero() {
  return <section className="relative bg-black overflow-hidden py-16 md:py-24" data-id="element-95">
      {/* Background with overlay */}
      <div className="absolute inset-0 z-0" data-id="element-96">
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/80 to-black z-10" data-id="element-97"></div>
        <img src="https://cdn.magicpatterns.com/uploads/xqVhznJjCFaoPUvotdLEDm/1783110295.png" alt="Conciencia Cósmica" className="w-full h-full object-cover opacity-50" data-id="element-98" />
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-8 relative z-20" data-id="element-99">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-100">
          <div className="md:w-1/2 space-y-8 text-center md:text-left" data-id="element-101">
            <div className="inline-block bg-amber-900/40 border border-amber-500/30 text-amber-400 px-4 py-1.5 rounded-full text-sm font-medium tracking-wider uppercase mb-2" data-id="element-102">
              Una Guía Simbólica de la Conciencia
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-poppins font-extrabold text-white leading-tight drop-shadow-lg text-center md:text-left" data-id="element-103">
              LIBRO DE LA{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-300 to-amber-600" data-id="element-104">
                SABIDURÍA
              </span>
            </h1>

            <h2 className="text-xl md:text-2xl font-poppins font-medium text-gray-300 text-center md:text-left" data-id="element-105">
              Descubre el lenguaje silencioso de tu mundo interior y despierta
              tu energía vital.
            </h2>

            <div className="bg-white/5 border-l-4 border-amber-500 p-5 backdrop-blur-sm rounded-r-lg" data-id="element-106">
              <p className="text-lg text-gray-200 italic" data-id="element-107">
                "No para que creas ciegamente. Sino para que observes. Para que
                reflexiones."
              </p>
            </div>

            <div className="pt-6 flex flex-col items-center md:items-start gap-4" data-id="element-108">
              <a href="#comprar" className="inline-flex items-center justify-center w-full md:w-auto bg-gradient-to-r from-amber-500 to-amber-700 hover:from-amber-400 hover:to-amber-600 text-black font-bold px-8 py-4 rounded-full text-lg transition-all duration-300 shadow-[0_0_20px_rgba(245,158,11,0.5)] transform hover:scale-105 active:scale-95 uppercase tracking-wide" data-id="element-109">
                Quiero comenzar mi viaje interior
              </a>
              <p className="text-gray-400 text-sm flex items-center gap-2" data-id="element-110">
                <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-111"></span>
                Acceso inmediato disponible
              </p>
            </div>
          </div>

          <div className="md:w-1/2 mt-8 md:mt-0 relative" data-id="element-112">
            <div className="relative rounded-2xl overflow-hidden shadow-[0_0_40px_rgba(245,158,11,0.2)] border border-white/10" data-id="element-113">
              <img src="https://cdn.magicpatterns.com/uploads/fv76ueuXSXpHkTgRccYtrc/COVER.png" alt="Libro de la Sabiduría" className="w-full h-auto object-cover transform hover:scale-105 transition-transform duration-700" data-id="element-114" />
              <div className="absolute top-4 left-4 bg-black/80 backdrop-blur-md text-amber-400 px-4 py-2 rounded-lg border border-amber-500/30 shadow-lg flex flex-col items-center" data-id="element-115">
                <span className="text-xs uppercase tracking-wider mb-1" data-id="element-116">
                  Oferta Especial
                </span>
                <span className="font-poppins font-bold text-xl" data-id="element-117">
                  $7.99 USD
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}